import { useState, useEffect} from "react"
import api from '../api'
import { chk_img, lang, gotoURL, gotoLink } from '../lang'
import { useNavigate } from 'react-router-dom';
import SwiperCore, { Navigation, Pagination, A11y, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import SwiperNavigation from "../Template/Swiper/SwiperNavigation";

SwiperCore.use([Navigation, Pagination, A11y]);
export default function Ebook(props) {
    const [resources, setResources] = useState([]);
    const [book_type, setBookType] = useState('book');
    const [collections, setCollections] = useState([]);
    const [collection_id, setCollectionId] = useState(0);
	const navigate = useNavigate();
    SwiperCore.use([Autoplay]); // start autoplay
    const styles = props.styles;

    useEffect(()=>{
        fetchInit();
    },[]);

    const fetchInit = async() => {
        try {
          const response = await api.get(`/book/type/book?show=12&order=id%20desc`);
          setResources(response.data.results);

          const collection_resp = await api.get(`/collection/home`);
          setCollections(collection_resp.data.results);
          console.log(collection_resp.data.results);
        } catch (err) {
            if(err.response){
                //Not in 202 response range
                console.log(err.response.data);
                console.log(err.response.headers);
                console.log(err.response.status);
            } else {
                console.log(`Error: ${err.message}`);
            }
        }
    }


    useEffect(()=>{
        const fetchBook = async () =>{
            try {
                if(book_type !== "collection"){
                    const response = await api.get(`/book/type/${book_type}?show=12&order=id%20desc`);
                    setResources(response.data.results);
                }else{
                    collections.forEach(element => {
                        if(collection_id === element.id){
                            setResources(element.books);
                        }
                    });
                }
            } catch (err) {
                if(err.response){
                    //Not in 202 response range
                    console.log(err.response.data);
                    console.log(err.response.headers);
                    console.log(err.response.status);
                } else {
                    console.log(`Error: ${err.message}`);
                }
            }
          }
        fetchBook();
    },[book_type]);


    function changeCollection(collection_id){
        setCollectionId(collection_id);
        setBookType('collection');
    }

    return (
        <div className={"ebook container "+styles[book_type]}>
            <div className={styles["book-shelf-menu"]}>
                <h2>New <span>Arrival</span></h2>
                <ul>
                    <li onClick={e=>setBookType("book")} className={(book_type==="book")?styles["active"]:''}>{lang('หนังสือใหม่','New Books')}</li>
                    <li onClick={e=>setBookType("journal")} className={(book_type==="journal")?styles["active"]:''}>{lang('วารสาร','Journals')}</li>
                    <li onClick={e=>setBookType("e-book")} className={(book_type==="e-book")?styles["active"]:''}>{lang('หนังสืออิเล็กทรอนิกส์','E-book')}</li>
                    <li onClick={e=>setBookType("e-journal")} className={(book_type==="e-journal")?styles["active"]:''}>{lang('วารสารอิเล็กทรอนิกส์','E-Journals')}</li>
                    {
                        collections.map((item, key) =>(
                            <li key={key} onClick={e=>changeCollection(item.id)} className={(book_type==="collection"&&collection_id===item.id)?styles["active"]:''}>
                                {lang(item.name,item.name_en)}
                            </li>
                        ))
                    }
                </ul>
                <div className={styles["book-shelf-desktop"]}>
                {/* <SwiperNavigation section="ebook" /> */}
                </div>
            </div>
            <div className={styles["book-shelf-mobile"]}>
                <ul className={styles["ebook-card"]}>
                {resources.map((item, key) =>(
                    <li key={key}>
                        <a href={item.link} target={item.target}>
                            <div className={styles["cover"]+" group"}>
                                <img src={chk_img(item.img_url)} alt={lang(item.title,item.title)} width="154" height="202" />
                            </div>
                            <span>{item.title}</span>
                        </a>
                    </li>
                ))}
                </ul>
                <div className={styles["readmore"]} onClick={() => navigate('/books')}>{lang('ดูทั้งหมด','View All')}</div>
            </div>
            <div className={styles["book-shelf"]}>
                <div className={styles["ebook-card"]}>
                {/* group items  */}
                <Swiper
                    slidesPerView={6}
                    centeredSlides={false}
                    speed={900}
                    autoplay={{ delay: 3000 }}
                    grabCursor={true}
                    breakpoints={{
                      // when window width is >= 320px
                      640: {
                        slidesPerView: 2,
                      },
                      // when window width is >= 640px
                      768: {
                        slidesPerView: 2,
                      },
                      // when window width is >= 992
                      1024: {
                        slidesPerView: 3,
                      },
                      // when window width is >= 992
                      1028: {
                        slidesPerView: 4,
                      },
                      1521: {
                        slidesPerView: 5,
                      }
                    }}
                    navigation={{
                      nextEl: ".swiper-button-next-unique",
                      prevEl: ".swiper-button-prev-unique"
                    }}
                    // pagination={{
                    //     el: ".ebook-swiper-pagination",
                    //     type: "bullets",
                    //     clickable: true
                    // }}
                    // navigation={{
                    //   nextEl: ".art-ebook-swiper-next",
                    //   prevEl: ".art-ebook-swiper-prev"
                    // }}
                    // modules={[Pagination]}
                    effect={"fade"}
                    className="ebook-swiper"
                >
                    {resources.map((item, index) => (
                        <SwiperSlide className="swiper-slide" key={index}>
                            <div className={styles["card"]+" group"}>
                            {(item.book_type==="e-book"||item.book_type==="e-journal")?(
                                <div className={styles["cover"]+" group"}>
                                    <img src={chk_img(item.img_url)} onClick={e=>gotoLink(item.link)} alt={lang(item.title,item.title)} width="154" height="202" />
                                    <span>{item.title}</span>
                                </div>
                            ):(
                                <div className={styles["cover"]+" group"}>
                                    <img src={chk_img(item.img_url)} onClick={e=>(item.book_type==="collection")?gotoURL(process.env.PUBLIC_URL + "/collection/"+item.id):gotoURL(process.env.PUBLIC_URL + "/book/"+item.id)} alt={lang(item.title,item.title)} width="154" height="202" />
                                    <span>{item.title}</span>
                                </div>
                            )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                    <div className="swiper-button-prev-unique"><FaChevronLeft /></div>
                    <div className="swiper-button-next-unique"><FaChevronRight /></div>
                </div>
                {/* <ul className={styles["ebook-card"]}>
                {resources.map((item, key) =>(
                    <li key={key}>
                        {(item.book_type==="e-book"||item.book_type==="e-journal")?(
                        <a href={item.link} target={item.target}>
                            <div className={styles["cover"]+" group"}>
                                <img src={chk_img(item.img_url)} alt={lang(item.title,item.title)} />
                            </div>
                            <span>{item.title}</span>
                        </a>
                        ):(
                            <a href={process.env.PUBLIC_URL + "/book/"+item.id} target={item.target}>
                                <div className={styles["cover"]+" group"}>
                                    <img src={chk_img(item.img_url)} alt={lang(item.title,item.title)} />
                                </div>
                                <span>{item.title}</span>
                            </a>
                        )}
                    </li>
                ))}
                </ul> */}
                <div className={styles["shelf"]}></div>
                <div className={styles["readmore"]} onClick={() => navigate('/resources')}>{lang('ดูทั้งหมด','View All')}</div>
            </div>
        </div>
    )
}
